<template>
    <v-container grid-list-md>
        <v-card-title>
            <CreateContactModalComponent :id="id" v-on:created="createContact($event)"></CreateContactModalComponent>
            <v-spacer></v-spacer>
            <v-text-field
                    v-model="search"
                    append-icon="search"
                    label="Search"
                    single-line
                    hide-details
            ></v-text-field>
        </v-card-title>

        <v-layout row wrap>
            <v-flex xs12 sm12 md12>
                <v-data-table
                        :headers="headers"
                        :items="contacts.data"
                        :search="search"
                        :pagination.sync="pagination"
                        hide-actions
                        :loading="loading"
                        :total-items="8"
                        v-on:update:pagination="ordenar"
                >
                    <template slot="items" slot-scope="props">
                        <td>{{ props.item.name }}</td>
                        <td class="text-xs">{{ props.item.email }} <v-icon left color="error" v-if="props.item.blocked">error</v-icon></td>
                        <td class="text-xs">{{ props.item.phone }}</td>
                        <td class="text-xs">{{ props.item.position }}</td>
                        <td class="layout px-0 align-center">
                            <v-menu
                                    transition="slide-y-transition"
                                    bottom
                                    left
                            >
                                <v-btn
                                        slot="activator"
                                        color="primary"
                                        dark
                                        fab
                                        flat
                                >
                                    <v-icon>settings</v-icon>
                                </v-btn>
                                <v-list>
                                    <v-list-tile>
                                        <EditContactModuleComponent :contact="props.item" v-on:update="updateContact($event)"></EditContactModuleComponent>
                                    </v-list-tile>
                                    <v-list-tile>
                                        <PermisosContactModule :id="id" :contact="props.item" v-on:guardar="savePermissions"></PermisosContactModule>
                                    </v-list-tile>
                                    <v-list-tile>
                                        <NotificationsContactModal :id="id" :contact="props.item" v-on:guardar="saveNotifications"></NotificationsContactModal>
                                    </v-list-tile>
                                    <v-list-tile class="justify-content-center">
                                        <v-btn flat v-on:click="sendresetPassword(props.item.email)"><v-icon left>send</v-icon>Send reset password</v-btn>
                                    </v-list-tile>
                                    <v-list-tile class="justify-content-center" v-if="props.item.blocked">
                                        <v-btn flat v-on:click="unblock(props.item.user_id)"><v-icon left>login</v-icon>Unblock</v-btn>
                                    </v-list-tile>
                                    <v-list-tile class="justify-content-center">
                                        <v-btn flat v-on:click="deleteContact(props.item.id)"><v-icon left>mdi-delete-circle</v-icon>Delete</v-btn>
                                    </v-list-tile>
                                </v-list>
                            </v-menu>
                        </td>
                    </template>
                    <v-alert slot="no-results" :value="true" color="error" icon="warning">
                        Your search for "{{ search }}" found no results.
                    </v-alert>
                </v-data-table>
            </v-flex>
            <v-flex xs12 sm12 md12>
                <div class="text-xs-center pt-4 pb-4" v-if="contacts.data">
                    <v-pagination
                            @input="setPage"
                            v-model="page"
                            :length="last_page"
                            color="secondary"
                            circle
                            :total-visible="7"
                    ></v-pagination>
                    <p class="subtitle">Showing {{ contacts.meta.from }} to {{ contacts.meta.to }} of {{ contacts.meta.total }} entries</p>
                </div>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
    import CreateContactModalComponent from '../components/CreateContactModalComponent';
    import EditContactModuleComponent from '../components/EditContactModalComponent';
    import PermisosContactModule from '../components/PermisosContactModal';
    import NotificationsContactModal from '../components/NotificationsContactModal';

    export default {
        props: ['id'],
        data () {
            return {
                dialog: false,
                contacts: [],
                search: '',
                headers: [
                    {
                        text: 'Name',
                        align: 'left',
                        sortable: true,
                        value: 'name'
                    },
                    { text: 'Email', value: 'email' },
                    { text: 'Phone', value: 'phone' },
                    { text: 'Position', value: 'position' },
                    { text: 'Actions', value: 'action', sortable: false }
                ],
                page: null,
                last_page: null,
                pagination: {},
                loading: true,
                fab: [],
                fling: false,
                hover: false,
                tabs: null,
                top: false,
                right: true,
                bottom: true,
                left: false,
                transition: 'slide-x-transition',
                direction: 'left',
                sortBy: 'name',
                order: 'asc',
            }
        },
        created () {
            this.getContacts();
            this.debouncedGetContacts = _.debounce(this.getContacts, 500)
        },
        watch: {
            search: function () {
                this.loading = true;
                this.debouncedGetContacts();
            },
            last_page: function () {
                if (this.page > this.contacts.meta.last_page) {
                    this.page = 1;
                }
            }
        },
        methods : {
            ordenar (payload) {
                this.sortBy = payload.sortBy;
                if (payload.descending) {
                    this.order = 'desc';
                } else {
                    this.order = 'asc';
                }
                this.getContacts();
            },
            setPage (page) {
                this.page = page;
                this.getContacts();
            },
            getContacts () {
                var params = {
                    filters : {
                        search: this.search,
                        page: this.page,
                        sortBy: this.sortBy,
                        order: this.order
                    },
                    client_id: this.id
                };

                this.$store.dispatch('getClientContacts', params).then((res) => {

                    this.contacts = res.data;
                    this.page = res.data.meta.current_page;
                    this.last_page = res.data.meta.last_page;
                    this.loading = false;

                    this.fab = [];

                    for (var i = 0; i < res.data.data.length; i++) {
                        this.fab.push(false);
                    }

                }).catch((error) => {

                });
            },
            deleteContact (contacto_id) {
                this.$confirm('Do you really want to delete?').then(res => {
                    if (res == true) {
                        this.$store.dispatch('deleteClientContact', {
                            cliente_id: this.id,
                            contact_id: contacto_id
                        }).then((res) => {
                            this.getContacts();
                        }).catch((error) => {

                        });
                    }
                })
            },
            createContact (contact) {
                this.$store.dispatch('createClientContact', contact).then((res) => {
                    this.getContacts();
                }).catch((error) => {

                });
            },
            updateContact (contact) {
                contact.cliente_id = this.id;
                this.$store.dispatch('updateClientContact', contact).then((res) => {
                    this.getContacts();
                }).catch((error) => {

                });
            },
            savePermissions (contact) {
                contact.cliente_id = this.id;
                this.$store.dispatch('updateClientContactPermissions', contact).then((res) => {
                    this.getContacts();
                }).catch((error) => {

                });
            },
            saveNotifications (contact) {
                contact.cliente_id = this.id;
                this.$store.dispatch('updateClientContactNotifications', contact).then((res) => {
                    this.getContacts();
                }).catch((error) => {

                });
            },
            sendresetPassword (email) {
                this.$store.dispatch('sendResetPassword', {
                    email: email
                }).then((res) => {
                }).catch((error) => {
                });
            },
            unblock (id) {
                this.$confirm('Do you really want to unblock the user?').then(res => {
                    if (res == true) {
                        this.$store.dispatch('unblockUser', {
                            id: id
                        }).then((res) => {

                            this.getContacts();

                        }).catch((error) => {

                        });
                    }
                })
            }
        },
        components: {
            CreateContactModalComponent,
            EditContactModuleComponent,
            PermisosContactModule,
            NotificationsContactModal
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/admin/clients/view/ContactComponent.vue